import React, { useEffect, useState } from "react";
import ChannelHeader from "../../../molecules/ChannelHeader";
import DropdownMenuFloat from "../../../molecules/DropdownMenuFloat";

export default function BandsWorkspaceChannelHeader({
    activeApp,
    canDeleteChannel,
    channel,
    defaultDescription,
    isDeletingChannel,
    isPresenceAvailable,
    onOpenMembers,
    onRequestDeleteChannel,
    onSelectTab,
    presenceSnapshot,
    selectedDirectChatId,
    tabs,
    workspaceId,
}) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [menuPosition, setMenuPosition] = useState(null);

    useEffect(() => {
        setIsMenuOpen(false);
        setMenuPosition(null);
    }, [activeApp, channel?.id, selectedDirectChatId, workspaceId]);

    if (!channel) {
        return null;
    }

    return (
        <>
            <ChannelHeader
                title={`#${channel.slug || channel.name}`}
                description={channel.description || defaultDescription}
                presence={{
                    isAvailable: Boolean(isPresenceAvailable),
                    onlineCount: presenceSnapshot?.onlineUserIds?.length || 0,
                    lastSeen: presenceSnapshot?.updatedAt ?? null,
                }}
                tabs={tabs}
                activeTab={activeApp}
                onSelectTab={onSelectTab}
                onMore={(event) => {
                    const evt = event?.nativeEvent || event;
                    const x = evt?.clientX ?? 0;
                    const y = evt?.clientY ?? 0;
                    setMenuPosition({ x, y });
                    setIsMenuOpen(true);
                }}
            />
            {isMenuOpen && (
                <DropdownMenuFloat
                    position={menuPosition}
                    onClose={() => setIsMenuOpen(false)}
                    items={[
                        {
                            label: "Add people to channel",
                            onClick: () => onOpenMembers(),
                        },
                        ...(canDeleteChannel
                            ? [{
                                label: isDeletingChannel ? "Deleting…" : "Delete channel",
                                onClick: () => onRequestDeleteChannel(channel),
                                tone: "danger",
                            }]
                            : []),
                    ]}
                />
            )}
        </>
    );
}
